// 名字生成的面纹图案:同一个名字永远画出同一张图,不含任何照片或人脸特征
function hashName(value: string) {
  let h = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    h ^= value.charCodeAt(index);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

function seeded(seed: number) {
  let a = seed;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export default function NameSigil({ name }: { name: string }) {
  const h = hashName(name.toLowerCase());
  const rand = seeded(h);
  const hueA = h % 360;
  const hueB = (hueA + 110 + (h >> 9) % 100) % 360;
  const left = Array.from({ length: 6 }, (_, index) => ({
    x: 24 + rand() * 22,
    y: 20 + index * 11 + rand() * 6,
  }));
  const right = left.map((point) => ({ x: 100 - point.x, y: point.y }));
  const path = (points: { x: number; y: number }[]) =>
    points.map((point, index) => `${index ? "L" : "M"}${point.x.toFixed(1)} ${point.y.toFixed(1)}`).join(" ");
  const id = `ns-${h.toString(36)}`;
  return (
    <svg className="fw-sigil" viewBox="0 0 100 100" role="img" aria-label={`@${name}`}>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={`hsl(${hueA} 90% 68%)`} />
          <stop offset="1" stopColor={`hsl(${hueB} 90% 70%)`} />
        </linearGradient>
      </defs>
      <ellipse cx="50" cy="52" rx="34" ry="42" fill="none" stroke={`url(#${id})`} strokeOpacity=".35" strokeWidth="1.2" />
      <g fill="none" stroke={`url(#${id})`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d={path(left)} />
        <path d={path(right)} />
        <path d={`M${left[1].x.toFixed(1)} ${left[1].y.toFixed(1)} L50 ${(left[2].y + 4).toFixed(1)} L${right[1].x.toFixed(1)} ${right[1].y.toFixed(1)}`} strokeOpacity=".7" />
        <path d={`M${left[4].x.toFixed(1)} ${left[4].y.toFixed(1)} Q50 ${(left[5].y + 6).toFixed(1)} ${right[4].x.toFixed(1)} ${right[4].y.toFixed(1)}`} strokeOpacity=".7" />
      </g>
      <g fill="#fff">
        {[...left, ...right].map((point, index) => (
          <circle key={index} cx={point.x} cy={point.y} r="1.6" opacity=".85" />
        ))}
      </g>
    </svg>
  );
}
